module.exports = __webpack_public_path__ + "assets/src/style/img/svg/logo-here-now-drenthe.svg?e5ce36016ea4becd47a53d37cb4dc44b";